import { createContext } from 'react';
import type { Session, User } from '@supabase/supabase-js';

export interface AuthState {
  user: User | null;
  session: Session | null;
  isLoading: boolean;
  error: Error | null;
}

export interface AuthContextValue extends AuthState {
  signInAnonymously: (captchaToken?: string) => Promise<void>;
  signOut: () => Promise<void>;
  linkEmail: (email: string, metadata?: Record<string, string>) => Promise<void>;
  verifyEmailOtp: (email: string, token: string) => Promise<void>;
  resendEmailOtp: (email: string) => Promise<void>;
  updateProfile: (data: Record<string, string>) => Promise<void>;
  sendLoginOtp: (
    email: string,
    options?: { metadata?: Record<string, string>; shouldCreateUser?: boolean }
  ) => Promise<void>;
  verifyLoginOtp: (email: string, token: string, metadata?: { fullName?: string; phone?: string }) => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
